import { FC } from 'react';

import { DataLink } from 'components/Shared/SharedComponents';
import { replaceContentfulVariables } from 'lib/text.service';

import styles from './DynamicModalWithStore.module.scss';

import type { ChildProps } from '../config/declarations';

export const ButtonSection: FC<ChildProps> = ({
  block,
  dynamicData,
}) => {
  if (!block || !block.link) {
    return null;
  }

  const button = block.link!;
  const backgroundImage = button.backgroundsCollection?.items?.[0]?.image?.url;
  const href = dynamicData?.extId
    ? `${button.src}?extid=${dynamicData.extId}`
    : button.src;

  return (
    <div className={styles.buttonWrapper}>
      <DataLink
        href={href || ''}
        link={button}
        className={styles.button}
        style={backgroundImage
          ? {
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'contain',
          }
          : {}}
      >
        {button?.title}
      </DataLink>
      {block.title && (
        <span className={styles.note}>
          {/* Will be replaced only for dynamic */}
          {replaceContentfulVariables(block.title, {
            min: dynamicData?.purchaseMinutes?.toString(),
          })}
        </span>
      )}
    </div>
  );
};
